module.exports = __webpack_public_path__ + "img/crm.b1a10e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/crm.png
// module id = W1jR
// module chunks = 12 13 16